export const CONFIRMATION_SOURCE_OPTIONS = [
  { value: "BITSO", label: "Bitso" },
  { value: "BINANCE", label: "Binance" },
  { value: "DAVIVIENDA", label: "Davivienda" },
  { value: "KAMIN", label: "Kamin" },
  { value: "KAMIN 2", label: "Kamin 2" },
  { value: "CXC IRIS BANK", label: "Iris" },
  { value: "TRUST", label: "Trust" },
  { value: "DROPI", label: "Dropi" },
  { value: "DROPLATAM", label: "Droplatam" },
  { value: "WIILOG", label: "Wiilog" },
  { value: "ALIADO", label: "Aliado" },
  { value: "CXC COBRU", label: "Cobru" },
  { value: "CXC AVOI", label: "Cxc Avoi" },
  { value: "OKX", label: "Okx" },
  { value: "BANCOLOMBIA", label: "Bancolombia" },
  { value: "BBVA", label: "BBVA" },
] as const;

export type ConfirmationSourceValue = (typeof CONFIRMATION_SOURCE_OPTIONS)[number]["value"];
